module.exports = __webpack_public_path__ + "static/media/Style Travel.8154d540.jpg";